
import { useState } from 'react';
import { Zap, MessageSquare, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FeedbackModal } from '@/components/FeedbackModal';

export function SharePromoBanner() {
  return null;
}
